<template>
  <ModuleContainer v-bind="bindModule">
    <template #btn>
      <MapControlButton
        v-if="!print.show"
        :active="print.show"
        icon="mdi-printer-outline"
        tooltip="In ấn"
        @click="onShowPrint()"
      />
      <template v-else>
        <MapControlGroupButton row>
          <MapControlButton
            icon="mdi-content-save-outline"
            :loading="print.loading"
            :tooltip="$t('actions.save')"
            @click="onSave()"
          />
          <MapControlButton
            :disabled="print.loading"
            icon="mdi-close"
            :tooltip="$t('actions.clear')"
            @click="onClosePrint()"
          />
        </MapControlGroupButton>
      </template>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import ModuleMixin from "@components/Map/mixins/ModuleMixin";

import MapControlGroupButton from "@components/Map/control/MapControlGroupButton.vue";
//import MapControlMenuButton from "@components/Map/control/MapControlMenuButton.vue";
import MapControlButton from "@components/Map/control/MapControlButton.vue";
import {
  CrosshairManager,
  PrintableAreaManager,
  exportCanvas,
  toPNG
} from "./print";
import { saveAs } from "file-saver";
export default {
  components: { MapControlButton, MapControlGroupButton },
  mixins: [ModuleMixin],
  data: (vm) => ({
    print: { show: false, loading: false }
  }),

  methods: {
    onDestroy() {
      this.onClosePrint();
    },
    async onSave() {
      if (!this.printableArea) return;
      this.print.loading = true;
      try {
        await this.onDownload(
          exportCanvas(this.map.getCanvas(), this.printableArea.getCutSize())
        );
      } finally {
        this.print.loading = false;
      }
    },
    onShowPrint() {
      this.print.show = true;
      this.toggleCrosshair(this.print.show);
      this.togglePrintableArea(this.print.show);
      this.map.on("resize", this.mapResizeBind);
    },
    onClosePrint() {
      this.print.loading = false;
      this.print.show = false;
      this.toggleCrosshair(this.print.show);
      this.togglePrintableArea(this.print.show);
      if (this.map) this.map.off("resize", this.mapResizeBind);
    },
    togglePrintableArea(show) {
      if (show === false) {
        if (this.printableArea !== undefined) {
          this.printableArea.destroy();
          this.printableArea = undefined;
        }
      } else {
        this.printableArea = new PrintableAreaManager(this.map.getCanvas());
        this.printableArea.create();
      }
    },
    toggleCrosshair(show) {
      if (show === false) {
        if (this.crosshair !== undefined) {
          this.crosshair.destroy();
          this.crosshair = undefined;
        }
      } else {
        this.crosshair = new CrosshairManager(this.map.getCanvas());
        this.crosshair.create();
      }
    },
    onInit() {
      this.mapResizeBind = this.onMapResize.bind(this);
    },
    onMapResize(e) {
      if (this.printableArea) {
        this.printableArea.mapResize();
      }
      if (this.crosshair) {
        this.crosshair.mapResize();
      }
    },
    async onDownload(data64) {
      if (this.$listeners["click:download"]) {
        this.$emit("click:download", data64);
        return;
      }
      saveAs(data64, "map.png");
    }
  }
};
</script>
<style>
.hidden-map {
  top: 0;
  right: 0;
  height: 0;
  width: 0;
  position: fixed;
}
</style>
